import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {
  Row,
  Col,
  Icon,
  Grid,
  Nav,
  Tab,
  Tabs,
  Table,
  NavItem,
  Panel,
  PanelHeader,
  PanelBody,
  PanelContainer,
  PanelTabContainer,
  Radio,
  Checkbox,
  FormGroup,
  InputGroup,
  ControlLabel,
  Button,
  Form,
  FormControl,
  Well,
} from '@sketchpixy/rubix';
import _ from 'lodash';

import Clinician from './components/Clinician';
import ClinicianDetail from './components/ClinicianDetail';
import Patient from './components/Patient';
import PatientDetail from './components/PatientDetail';

export default class CpMappingClinician extends Component {
  constructor(props) {
    super(props);
    this.state = {
        currentView: 'LIST',
        activeTab: 'CLINICIAN-PATIENTS',
        clinicianId: null,
        patientId: null,
    };
  }

  componentDidMount() {
  }

  handleActiveState(eventKey) {
        this.setState({
          activeTab: eventKey,
          currentView: 'LIST'
        });
  }

  editPatientMapping = (clinicianId) => {
	  this.setState({clinicianId,currentView:'DETAIL'});
  }
  editClinicianMapping = (patientId) => {
	  this.setState({patientId, currentView:'DETAIL'});
  }

  showListHandler = () => {
     this.setState({
          currentView: 'LIST'
      });
  }

  render() {
    return (
        <PanelTabContainer id='tabs-basic' defaultActiveKey="CLINICIAN-PATIENTS">
            <PanelHeader className='bg-pinkishred fg-white'>
              <Grid>
                <Row>
                  <Col sm={12}>
                     <h1>Clinician - Patients Mapping</h1>
                  </Col>
                </Row>
              </Grid>
             </PanelHeader>
              <PanelBody>
                   <Grid>
                     <Row>
                       <Col sm={12} collapseRight>
                       <Nav bsStyle="tabs" className='tab-lightgreen' onSelect={::this.handleActiveState} >
                       <NavItem eventKey="CLINICIAN-PATIENTS">Clinician-Patient</NavItem>
                       <NavItem eventKey="PATIENTS-CLINICIAN">Patient-Clinician</NavItem>
                     </Nav>
                     <Tab.Content>
                       <Tab.Pane eventKey="CLINICIAN-PATIENTS">
                          <div style={{display: this.state.currentView === 'LIST' ? 'block' : 'none' }}>
                            <Clinician editPatientMapping={this.editPatientMapping}></Clinician>
                          </div>
                          {
                              (() => {
                                  if (this.state.currentView === 'DETAIL') {
                                    return <ClinicianDetail clinicianId={this.state.clinicianId} showListHandler={this.showListHandler}></ClinicianDetail>
                                  } 
                              })()
                           }
                       </Tab.Pane>
                       <Tab.Pane eventKey="PATIENTS-CLINICIAN">
                           <div style={{display: this.state.currentView === 'LIST' ? 'block' : 'none' }}>
                               <Patient editClinicianMapping={this.editClinicianMapping}></Patient>
                           </div>
                           {
                               (() => {
                                   if (this.state.currentView === 'DETAIL') {
                                     return <PatientDetail patientId={this.state.patientId} showListHandler={this.showListHandler}></PatientDetail>
                                   } 
                               })()
                             }
                       </Tab.Pane>
                     </Tab.Content>
                       </Col>
                     </Row>
              </Grid>
          </PanelBody>
        </PanelTabContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/cp-mapping/CpMapping.js